/**
 * Upfront action configuration for SMS/Twilio deployments.
 */

import { z } from "zod";

/**
 * Upfront action configuration (SMS variant)
 */
export const UpfrontActionSchema = z.object({
  name: z.string(),
  input: z.unknown()
});

export type UpfrontAction = z.infer<typeof UpfrontActionSchema>;
